export const createProxyObject = object => {
    return new Proxy(object, {
        get: function (object, property) {
            return Object.prototype.hasOwnProperty.call(object, property) ? object[property] : object.default;
        },
    });
};
